import { render, staticRenderFns } from "./ComponentLoader.vue?vue&type=template&id=b3fa2f78&scoped=true&lang=html&"
import script from "./ComponentLoader.vue?vue&type=script&lang=js&"
export * from "./ComponentLoader.vue?vue&type=script&lang=js&"
import style0 from "./ComponentLoader.vue?vue&type=style&index=0&id=b3fa2f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fa2f78",
  null
  
)

export default component.exports